export default "__VITE_ASSET__6cea0a5c__"